import IMedicalMember from '../interfaces/IMedicalMember';
import { BASE_PATH } from '../constants/services.constants';
import Api from './Api';

export const getMedicalMembers = async (): Promise<IMedicalMember[]> => {
  const { medicalMembers } = await Api.get(`${BASE_PATH}/medical_members`);
  return medicalMembers;
};
